export const shadow = {
    lightShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    lightHover: '1px 5px 4px rgba(0, 0, 0, 0.05)',
    lightOutline: '0 1px 0px 0px rgba(0, 0, 0, 0.05)',
    lightAccent: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    mediumShadow: '0 0 8px 0 rgba(0, 0, 0, 0.15)',
    mediumHover: '3px 4px 8px rgba(0, 0, 0, 0.15)',
    heavyShadow: '4px 9px 9px rgba(0, 0, 0, 0.1)'
};
